import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {
  NbButtonModule,
  NbCardModule,
  NbProgressBarModule,
  NbTabsetModule,
  NbUserModule,
  NbIconModule,
  NbSelectModule,
  NbListModule,
  NbMenuModule,
  NbSidebarModule,
  NbTreeGridModule,
  NbInputModule,
  NbCheckboxModule,
  NbSpinnerModule,
} from '../../common/public_api';

import { LookupsComponent } from './lookups.component';
import { FsIconComponent } from '../../tables/tree-grid/tree-grid.component';
import { AddLookupModalComponent } from './add-lookup-modal/add-lookup-modal.component';

import { NgxCommonModule } from '../../common/ngx-common.module';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    NgxCommonModule,
    NbCardModule,
    NbUserModule,
    NbButtonModule,
    NbIconModule,
    NbTabsetModule,
    NbSelectModule,
    NbListModule,
    NbTreeGridModule,
    NbProgressBarModule,
    NbMenuModule,
    NbSidebarModule,
    RouterModule,
    NbInputModule,
    NbCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    NbSpinnerModule,
  ],
  declarations: [
    LookupsComponent,
    AddLookupModalComponent,
  ],
  entryComponents: [
    AddLookupModalComponent,
  ],
  providers: [],
})
export class LookupsModule { }
